import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsOptional, IsString, ValidateNested } from "class-validator";

export class Contractor {
  @IsOptional()
  @IsString()
  @Expose()
  id!: string | null;
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  surname!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  shortName!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  tin!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  comment!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  nationalBusinessRegistryNumber!: string | null;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
  @IsBoolean()
  @Expose()
  isIndividual!: boolean;
  @IsOptional()
  @IsString()
  @Expose()
  streetAndNumber!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  country!: string;
  @IsOptional()
  @IsString()
  @Expose()
  city!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  postalCode!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  email!: string | null;

  constructor() {
    this.id = null;
    this.isIndividual = true;
    this.country = "";
    this.city = "";
    this.comment = "";
    this.email = "";
    this.isLocked = false;
    this.name = "";
    this.shortName = "";
    this.nationalBusinessRegistryNumber = "";
    this.postalCode = "";
    this.tin = "";
    this.surname = "";
  }
}

export class ContractorBasicInfo {
  @IsOptional()
  @IsString()
  @Expose()
  id!: string | null;
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  tin!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  country!: string;
  @IsOptional()
  @IsString()
  @Expose()
  city!: string | null;

  constructor() {
    this.id = null;
    this.name = "";
    this.tin = "";
    this.country = "";
    this.city = "";
  }
}

export class GetContractorResponse extends GenericTableResponse<Contractor> {
  @Type(() => Contractor)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<Contractor>;
}

export class KpContractor {
  @IsOptional()
  @IsString()
  @Expose()
  importedContractorId!: string | null;
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  surname!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  shortName!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  tin!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  nationalBusinessRegistryNumber!: string | null;
  @IsBoolean()
  @Expose()
  isIndividual!: boolean;
  @IsOptional()
  @IsString()
  @Expose()
  streetAndNumber!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  country!: string;
  @IsOptional()
  @IsString()
  @Expose()
  city!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  postalCode!: string | null;
}
